export default __webpack_public_path__ + "static/media/img-clients_3.6e4a46e4.png";